import { render, staticRenderFns } from "./BlockDetails.vue?vue&type=template&id=4d20b15e"
import script from "./BlockDetails.vue?vue&type=script&lang=js"
export * from "./BlockDetails.vue?vue&type=script&lang=js"
import style0 from "./BlockDetails.vue?vue&type=style&index=0&id=4d20b15e&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports